import { render, staticRenderFns } from "./OnBoardingInvitationCard.vue?vue&type=template&id=2c122c77&scoped=true"
import script from "./OnBoardingInvitationCard.vue?vue&type=script&lang=ts"
export * from "./OnBoardingInvitationCard.vue?vue&type=script&lang=ts"
import style0 from "./OnBoardingInvitationCard.vue?vue&type=style&index=0&id=2c122c77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c122c77",
  null
  
)

export default component.exports